import { render, staticRenderFns } from "./AppTableItem.vue?vue&type=template&id=25c2d64b&scoped=true&"
import script from "./AppTableItem.vue?vue&type=script&lang=js&"
export * from "./AppTableItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTableItem.vue?vue&type=style&index=0&id=25c2d64b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2d64b",
  null
  
)

export default component.exports